import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DialogServiceCustom } from '../../service/dialog.service';

@Component({
  selector: 'app-success-error-dialog',
  imports: [DialogModule, ButtonModule],
  templateUrl: './success-error-dialog.component.html',
  styleUrl: './success-error-dialog.component.scss', schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SuccessErrorDialogComponent implements OnInit {

  // Control visibility of the dialogs
  displayDialog: boolean = false;

  // Data variables
  isSuccess: boolean = false; // Set to true for success or false for error
  description: string = ''; // Replace dynamically if needed

  constructor(
    private dialogService: DialogServiceCustom
  ) { }

  ngOnInit(): void {
    // Register the component reference in the service
    this.dialogService.setDialogRef(this);
  }

  /**
   * Opens the dialog, shows the username, and closes it after 5 seconds.
   * @param isSuccess Boolean flag to indicate success or error.
   * @param username The user's name to display.
   */
  openDialog(isSuccess: boolean, description: string, onClose: () => void): void {
    this.isSuccess = isSuccess;
    this.description = description;
    this.displayDialog = true;

    // Automatically close the dialog after 5 seconds
    setTimeout(() => {
      this.displayDialog = false;
      onClose();
    }, 5000);
  }

}
